import React, { useState, useContext, useCallback } from "react";
import { Link as RouterLink } from "react-router-dom";

import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Link
} from "@material-ui/core";

import { Visibility, VisibilityOff } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import AuthLayout from "../../components/AuthLayout";

const useStyles = makeStyles(theme => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    minHeight: 48,
    fontWeight: 700
  },
  formLinks: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    marginTop: theme.spacing(1)
  }
}));

const Login = () => {
  const classes = useStyles();

  const [user, setUser] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [userCreationEnabled, setUserCreationEnabled] = useState(true);

  const { handleLogin } = useContext(AuthContext);
  const handleUserCreationLoaded = useCallback(
    enabled => setUserCreationEnabled(enabled),
    []
  );

  const handleChangeInput = e => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handlSubmit = e => {
    e.preventDefault();
    handleLogin(user);
  };

  return (
    <AuthLayout onUserCreationLoaded={handleUserCreationLoaded}>
      <form className={classes.form} noValidate onSubmit={handlSubmit}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label={i18n.t("login.form.email")}
          name="email"
          value={user.email}
          onChange={handleChangeInput}
          autoComplete="email"
          autoFocus
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label={i18n.t("login.form.password")}
          id="password"
          value={user.password}
          onChange={handleChangeInput}
          autoComplete="current-password"
          type={showPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(e => !e)}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          {i18n.t("login.buttons.submit")}
        </Button>
        <div className={classes.formLinks}>
          <Link variant="body2" component={RouterLink} to="/forgot-password">
            Olvidé mi contraseña
          </Link>
          {userCreationEnabled && (
            <Link variant="body2" component={RouterLink} to="/signup">
              {i18n.t("login.buttons.register")}
            </Link>
          )}
        </div>
      </form>
    </AuthLayout>
  );
};

export default Login;
